import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api-client';

/** The one definition of this read: the coach's own settings. */
export function settingsOptions() {
  return api.queryOptions('get', '/me/settings');
}

/** The coach's settings; the invite dialog reads the default message from them. */
export function useCoachSettings() {
  return useQuery(settingsOptions());
}
